import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const RecoveryChart = ({ data }) => {
  const chartData = data?.map(item => ({
    date: new Date(item?.date)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    score: item?.recovery_score,
    sleep: item?.sleep_hours ? item?.sleep_hours * 10 : null,
    hrv: item?.heart_rate_variability,
    rhr: item?.resting_heart_rate
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
        <XAxis 
          dataKey="date" 
          stroke="#9CA3AF"
          style={{ fontSize: '12px' }}
        />
        <YAxis 
          stroke="#9CA3AF"
          style={{ fontSize: '12px' }}
        />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: '#1F2937', 
            border: '1px solid #374151',
            borderRadius: '8px'
          }}
          labelStyle={{ color: '#F3F4F6' }}
        />
        <Legend 
          wrapperStyle={{ fontSize: '12px' }}
        />
        <Line 
          type="monotone" 
          dataKey="score" 
          stroke="#8B5CF6" 
          strokeWidth={2}
          name="Recovery Score"
          dot={{ fill: '#8B5CF6', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="sleep" 
          stroke="#3B82F6" 
          strokeWidth={2}
          name="Sleep (x10 hrs)"
          dot={{ fill: '#3B82F6', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="hrv" 
          stroke="#EF4444" 
          strokeWidth={2}
          name="HRV (ms)"
          dot={{ fill: '#EF4444', r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="rhr" 
          stroke="#EC4899" 
          strokeWidth={2}
          name="RHR (bpm)"
          dot={{ fill: '#EC4899', r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RecoveryChart;